import {Link, useLocation} from 'react-router-dom';
import React, {useContext, useState} from 'react';
import EventEmitter from '../utils/emmiter';
import {UserContext} from '../utils/usercontext';
//import AudioPlayer from './components/audio/audioplayer';
import {/*useracc, */postApi, putApi} from '../utils/functions';

//import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
//import './components/fontawesome/fontawesome';

//import Row from 'react-bootstrap/Row';
//import Col from 'react-bootstrap/Col';
import Dropdown from 'react-bootstrap/Dropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Nav from 'react-bootstrap/Nav';

//import './css/header.css';

export default function Header() {

	//const [metaClubbers, setMetaClubbers] = useState({connected: 0, dj: '', artist: '', title: '', art: '', time: 0, listeners: 0});
	//const [metaRadio, setMetaRadio] = useState({connected: 0, dj: '', artist: '', title: '', art: '', time: 0, listeners: 0});
	
	const {user} = useContext(UserContext);
	const [page, setPage] = useState({parent: '', sub: ''});
	//const [subPage, setSubPage] = useState('');
	const [mobile, setmobile] = useState(false);
	const [hover, setHover] = useState(false);
	const [index, setIndex] = useState(-1);
	//const [size, setSize] = useState([0, 0]);
	const [active, setActive] = useState(false);

  const [services, setServices] = useState([]);
	const [cart, setCart] = useState([]);
	//const [notification, setNotification] = useState(true);
	const [notifications, setNotifications] = useState(true);
	
	const [showDropdown, setDropdown] = useState(false);

	let location = useLocation();

  async function Loadheader() {
    let params = new URLSearchParams();

		let cookies = document.cookie.split(';');
		cookies = cookies.map(cookie => cookie.split("="));
		for( let i in cookies ) {
			if( cookies[i][0] === 'order' ) {
				params.append('order', cookies[i][1]);
			}
		}
		const x = await postApi('/v3/portal/header', params);
		//console.log(x.data);

		for( let i in x.data.Services ) {
			let params = new URLSearchParams();
			params.append('service', x.data.Services[i].id);
			params.append('uid', user.user.id);
			const y = await postApi('/v3/service/header', params);
			//console.log(y.data);
			for( let j in y.data ) {
				x.data.Services[i][j] = y.data[j];
			}
		}
    setServices(x.data.Services);
		setCart(x.data.Order);
  }

	/*function toggleSidemenu(event) {
		let element = document.getElementById('landing-page-wrapper');
		if( element && element.contains(event.target) ) { // or use: event.target.closest(selector) === null
			let html = document.documentElement;
			if( html ) html.setAttribute("data-toggled", 'close');
		}


	}*/

	function openSidemenu() {
		let element = document.documentElement;
		
		if( window.innerWidth < 992 ) {
			setActive(true);
			element.removeAttribute("data-toggled");
			setTimeout(()=>{
				element.removeAttribute("data-toggled");
			},100);
		} else {
			let attribute = element.getAttribute("data-toggled");
			
			if( attribute ) {
				element.removeAttribute("data-toggled");
				setHover(false);
			} else {
				element.setAttribute("data-toggled", "icon-overlay-close");
				setHover(true);
			}
		}
		
	}

	function toggleSidemenu(status) {
		if( hover ) {
			let element = document.documentElement;
			//let attribute = element.getAttribute("data-toggled");
			
			if( status ) {
				element.removeAttribute("data-toggled");
				if( window.innerWidth < 992 ) setActive(true);

			} else {
				element.setAttribute("data-toggled", "icon-overlay-close");
			}
		}
	}


	function changeMode() {
		let element = document.documentElement;
		let attribute = element.getAttribute("data-theme-mode");
		if( attribute === 'light' ) {
			element.setAttribute("data-theme-mode", "dark");
		} else {
			element.setAttribute("data-theme-mode", "light");
		}

		let params = new URLSearchParams();
		params.append('theme_mode', attribute === 'light'?'dark':'light');
		putApi('/v3/account/theme', params);
		
	}

	function closeSidebar() {
		//if( window.innerWidth > 991 )
		setActive(false);
		let element = document.documentElement;
		element.setAttribute("data-toggled", "close");
	}

	React.useEffect(() => {

    Loadheader();

		function updateSize() {
			let element = document.documentElement;
			if( window.innerWidth < 992 ) {
				element.setAttribute("data-toggled", "close");
			} else {
				
				element.removeAttribute("data-toggled");
			}
      //setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();

		EventEmitter.addListener('/portal/user', async data => {
			Loadheader();
			//setMetaClubbers(data.azura);
		});

		/*EventEmitter.addListener('/clubbers/meta', async data => {
			//setMetaClubbers(data.azura);
		});
		EventEmitter.addListener('/radio/meta', async data => {
			//setMetaRadio(data.azura);
		});*/

		let _page = location.pathname.split('/');
		
		setPage({parent: _page[1]?_page[1]:'', sub: _page[2]?_page[2]:''}); 

		/*switch(true) {
			
			case /^\/streamkey/.test(location.pathname):
				
				setPage({parent: 'streamkey', sub: ''}); 
				break;
			case /^\//.test(location.pathname):
				
				setPage({parent: '', sub: ''}); 
				break;
		}*/

    /*
		switch(true) {
			case /^\/about/.test(location.pathname):
				setPage('mix365'); setSubPage('about');
				break;
			case /^\/events/.test(location.pathname):
				setPage('mix365'); setSubPage('events');
				break;
			case /^\/mix365djs/.test(location.pathname):
				setPage('mix365'); setSubPage('mix365djs');
				break;
			case /^\/previous-sets/.test(location.pathname):
				setPage('mix365'); setSubPage('previous-sets');
				break;
			case /^\/listen/.test(location.pathname):
				setPage('mix365'); setSubPage('listen');
				break;
			
			case /^\/schedule/.test(location.pathname):
				setPage('schedule'); setSubPage('');
				break;

			case /^\/clubbers\/schedule/.test(location.pathname):
				setPage('schedule'); setSubPage('clubbers/schedule');
				break;
			case /^\/clubbers/.test(location.pathname):
				setPage('chatlive'); setSubPage('clubbers');
				break;
			case /^\/radio\/schedule/.test(location.pathname):
				setPage('schedule'); setSubPage('radio/schedule');
				break;
			case /^\/radio/.test(location.pathname):
				setPage('chatlive'); setSubPage('radio');
				break;

			case /^\/contact/.test(location.pathname):
				setPage('contact'); setSubPage('contact');
				break;
			case /^\/apply/.test(location.pathname):
				setPage('contact'); setSubPage('apply');
				break;
			case /^\/advertise/.test(location.pathname):
				setPage('contact'); setSubPage('advertise');
				break;

			case /^\/shop/.test(location.pathname):
				setPage('shop'); setSubPage('');
				break;

			case /^\/login/.test(location.pathname):
				setPage('login'); setSubPage('');
				break;

			case /^\/register/.test(location.pathname):
				setPage('register'); setSubPage('');
				break;

			case /^\/djarea$/.test(location.pathname):
				setPage('djarea'); setSubPage('djarea');
				break;
			case /^\/djarea\/members/.test(location.pathname):
				setPage('djarea'); setSubPage('djarea/members');
				break;
			case /^\/djarea\/connection/.test(location.pathname):
				setPage('djarea'); setSubPage('djarea/connection');
				break;
			case /^\/djarea\/socials/.test(location.pathname):
				setPage('djarea'); setSubPage('djarea/socials');
				break;
			case /^\/djarea\/posters/.test(location.pathname):
				setPage('djarea'); setSubPage('djarea/posters');
				break;
			case /^\/djarea\/files/.test(location.pathname):
				setPage('djarea'); setSubPage('djarea/files');
				break;
			case /^\/djarea\/logs/.test(location.pathname):
				setPage('djarea'); setSubPage('djarea/logs');
				break;


			case /^\/admin$/.test(location.pathname):
				setPage('admin'); setSubPage('admin');
				break;
			case /^\/admin\/djaccounts/.test(location.pathname):
				setPage('admin'); setSubPage('admin/djaccounts');
				break;
			case /^\/admin\/events/.test(location.pathname):
				setPage('admin'); setSubPage('admin/events');
				break;
			case /^\/admin\/weekly/.test(location.pathname):
				setPage('admin'); setSubPage('admin/weekly');
				break;
			case /^\/admin\/publish/.test(location.pathname):
				setPage('admin'); setSubPage('admin/publish');
				break;
			case /^\/admin\/seo/.test(location.pathname):
				setPage('admin'); setSubPage('admin/seo');
				break;

			default:
				setPage('index'); setSubPage('');
				break;
		}
    */
  }, [location]);
	

	

	const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
		<a className="header-link dropdown-toggle" id="mainHeaderProfile" href="" ref={ref} onClick={(e)=>{e.preventDefault();onClick(e);}} style={{padding: '1.4rem'}}>
			{children}
		</a>
	));

	const CustomMenu = React.forwardRef(({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
		const [value, setValue] = useState('');
		return (
			<div ref={ref} style={style} className={className} aria-labelledby={labeledBy}>
				<ul className="dropdown-menu border-0 main-header-dropdown  overflow-hidden header-profile-dropdown show" aria-labelledby="mainHeaderProfile">
					{React.Children.toArray(children).filter(
						(child) => !value || child.props.children.toLowerCase().startsWith(value),
					)}
				</ul>
			</div>
		);
	});
	

	function toggleDropdown(option) {
		//console.log(option, showDropdown);
		if( showDropdown === option ) {
			setDropdown(false);
		} else {
			setDropdown(option);
		}
	}

	function SidemenuHeader(props) {
		//console.log(props);
		return (
			<>
				<li className="slide__category"><span className="category-name">{props.service.product}</span></li>
				<li className="slide has-sub">
					<Link to={`/${props.service.id}`} className={`side-menu__item ${parseInt(page.parent)===props.service.id&&page.sub===''?'active':''}`}>
						<span className=" side-menu__icon">
							<i className='bx bx-home'></i>
						</span>
						<span className="side-menu__label">{props.service.title.length>0?props.service.title:'Overview'}</span>
						{props.service?._radio?.overview > 0 &&
							<div className="side-menu__angle">
								<span className="badge bg-success-transparent ms-2 d-inline-block">
									{props.service._radio.overview}
								</span>
							</div>
						}
					</Link>
				</li>
			</>
		)
	}

	function SidemenuLiveStream(props) {
		return (
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/live`} className={`side-menu__item ${parseInt(page.parent)===props.service.id&&page.sub==='live'?'active':''}`}>
					<span className=" side-menu__icon">
						<i className='bx bx-video'></i>
					</span>
					<span className="side-menu__label">Live Stream</span>
					{props.service?._radio?.livestream > 0 &&
						<div className="side-menu__angle">
							<span className="badge bg-success-transparent ms-2 d-inline-block">
								{props.service._radio.livestream}
							</span>
						</div>
					}
				</Link>
			</li>
		)
	}

	function SidemenuSchedule(props) {
		return (
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/schedule`} className={`side-menu__item ${parseInt(page.parent)===props.service.id&&page.sub==='schedule'?'active':''}`}>
					<span className=" side-menu__icon">
						<i className='bx bx-list-ul'></i>
					</span>
					<span className="side-menu__label">Schedule</span>
					{props.service?._radio?.schedule > 0 &&
						<div className="side-menu__angle">
							<span className="badge bg-success-transparent ms-2 d-inline-block">
								{props.service._radio.schedule}
							</span>
						</div>
					}
				</Link>
			</li>
		)
	}

	function SidemenuEmojiCrew(props) {
		return (
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/template`} className={`side-menu__item ${parseInt(page.parent)===props.service.id&&page.sub==='template'?'active':''}`}>
					<span className=" side-menu__icon">
						<i className='bx bx-party'></i>
					</span>
					<span className="side-menu__label">EmojiCrew</span>
					{props.service?._radio?.emojicrew > 0 &&
						<div className="side-menu__angle">
							<span className="badge bg-success-transparent ms-2 d-inline-block">
								{props.service._radio.emojicrew}
							</span>
						</div>
					}
				</Link>
			</li>
		)
	}

	function SidemenuAnalytics(props) {
		return (
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/analytics`} className={`side-menu__item ${parseInt(page.parent)===props.service.id&&page.sub==='analytics'?'active':''}`}>
					<span className=" side-menu__icon">
						<i className='bx bx-bar-chart'></i>
					</span>
					<span className="side-menu__label">Analytics</span>
					{props.service?._radio?.analytics > 0 &&
						<div className="side-menu__angle">
							<span className="badge bg-success-transparent ms-2 d-inline-block">
								{props.service._radio.analytics}
							</span>
						</div>
					}
				</Link>
			</li>
		)
	}

	function SidemenuDropsJingles(props) {
		return (
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/filemanager`} className={`side-menu__item ${parseInt(page.parent)===props.service.id&&page.sub==='filemanager'?'active':''}`}>
					<span className=" side-menu__icon">
						<i className='bx bx-podcast'></i>
					</span>
					<span className="side-menu__label">File Manager</span>
					{props.service?._radio?.filemanager > 0 &&
						<div className="side-menu__angle">
							<span className="badge bg-success-transparent ms-2 d-inline-block">
								{props.service._radio.filemanager}
							</span>
						</div>
					}
				</Link>
			</li>
		)
	}

	function SidemenuReplays(props) {
		return (
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/replays`} className={`side-menu__item ${parseInt(page.parent)===props.service.id&&page.sub==='replays'?'active':''}`}>
					<span className=" side-menu__icon">
						<i className='bx bx-play-circle'></i>
					</span>
					<span className="side-menu__label">Replays</span>
					{props.service?._radio?.replays > 0 &&
						<div className="side-menu__angle">
							<span className="badge bg-success-transparent ms-2 d-inline-block">
								{props.service._radio.replays}
							</span>
						</div>
					}
				</Link>
			</li>
		)
	}

	function SidemenuAdmin(props) {
		return (
			<>
				<li className="slide has-sub">
					<div style={{borderTop: '1px solid rgba(255, 255, 255, .1)'}}></div>
				</li>
				<li className="slide has-sub">
					<Link to={`/${props.service.id}/admin`} className={`side-menu__item ${parseInt(page.parent)===props.service.id&&page.sub==='admin'?'active':''}`}>
						<span className=" side-menu__icon">
							<i className='bx bx-lock-alt'></i>
						</span>
						<span className="side-menu__label">Admin Overview</span>
						{props.service?._admin?.overview > 0 &&
							<div className="side-menu__angle">
								<span className="badge bg-success-transparent ms-2 d-inline-block">
									{props.service._admin.overview}
								</span>
							</div>
						}
					</Link>
				</li>
			</>
		)
	}

	function SidemenuInvites(props) {
		return (
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/invites`} className={`side-menu__item ${parseInt(page.parent)===props.service.id&&page.sub==='invites'?'active':''}`}>
					<span className=" side-menu__icon">
						<i className='bx bx-user'></i>
					</span>
					<span className="side-menu__label">Invites</span>
					{props.service?._admin?.invites > 0 &&
						<div className="side-menu__angle">
							<span className="badge bg-success-transparent ms-2 d-inline-block">
								{props.service._admin.invites}
							</span>
						</div>
					}
				</Link>
			</li>
		)
	}

	function SidemenuDJAccounts(props) {
		return (
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/accounts`} className={`side-menu__item ${parseInt(page.parent)===props.service.id&&page.sub==='accounts'?'active':''}`}>
					<span className=" side-menu__icon">
						<i className='bx bx-user-plus'></i>
					</span>
					<span className="side-menu__label">DJ Accounts</span>
					{props.service?._admin?.accounts > 0 &&
						<div className="side-menu__angle">
							<span className="badge bg-success-transparent ms-2 d-inline-block">
								{props.service._admin.accounts}
							</span>
						</div>
					}
				</Link>
			</li>
		)
	}

	function SidemenuPlatforms(props) {
		return(
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/platforms`} className={`side-menu__item ${parseInt(page.parent)===props.service.id&&page.sub==='platforms'?'active':''}`}>
					<span className=" side-menu__icon">
						<i className='bx bx-video-plus'></i>
					</span>
					<span className="side-menu__label">Streaming Platforms</span>
					{props.service?._admin?.platforms > 0 &&
						<div className="side-menu__angle">
							<span className="badge bg-success-transparent ms-2 d-inline-block">
								{props.service._admin.platforms}
							</span>
						</div>
					}
				</Link>
			</li>
		)
	}
	function SidemenuDiscord(props) {
		return(
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/discord`} className={`side-menu__item ${parseInt(page.parent)===props.service.id&&page.sub==='discord'?'active':''}`}>
					<span className=" side-menu__icon">
						<i className='bx bxl-discord-alt' type="logo"></i>
					</span>
					<span className="side-menu__label">Discord</span>
					{props.service?._admin?.discord > 0 &&
						<div className="side-menu__angle">
							<span className="badge bg-success-transparent ms-2 d-inline-block">
								{props.service._admin.discord}
							</span>
						</div>
					}
				</Link>
			</li>
		)
	}
	function SidemenuEmbeds(props) {
		return(
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/embeds`} className={`side-menu__item ${parseInt(page.parent)===props.service.id&&page.sub==='embeds'?'active':''}`}>
					<span className=" side-menu__icon">
						<i className='bx bx-anchor'></i>
					</span>
					<span className="side-menu__label">Website Embeds</span>
					{props.service?._admin?.embeds > 0 &&
						<div className="side-menu__angle">
							<span className="badge bg-success-transparent ms-2 d-inline-block">
								{props.service._admin.embeds}
							</span>
						</div>
					}
				</Link>
			</li>
		)
	}
	function SidemenuOrganiser(props) {
		return (
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/organiser`} className="side-menu__item">
					<span className=" side-menu__icon">
						<i className='bx bx-list-check'></i>
					</span>
					<span className="side-menu__label">Schedule Organiser</span>
					<i className="fe fe-chevron-right side-menu__angle"></i>
				</Link>
			</li>
		)
	}

	function SidemenuVideos(props) {
		return (
			<li className="slide has-sub">
				<Link to={`/${props.service.id}/recordings`} className="side-menu__item">
					<span className=" side-menu__icon">
						<i className='bx bx-video-recording'></i>
					</span>
					<span className="side-menu__label">Video Recordings</span>
					<i className="fe fe-chevron-right side-menu__angle"></i>
				</Link>
			</li>
		)
	}

	return (
		<>
			{user?.user &&
				<>
					<header id="landing-page-wrapper" className="app-header sticky-pin">
						<div className="main-header-container container-fluid">

							<div className="header-content-left">
								<div className="header-element">
									<div className="horizontal-logo">
										<a href="https://laravelui.spruko.com/velvet/index" className="header-logo">
											<img src={`https://cloud.ultrastream.io/images/logo-us-large.png?d=${Math.floor(Date.now()/1000)}`} alt="logo" className="desktop-logo" />
											<img src={`https://cloud.ultrastream.io/images/logo-us.png?d=${Math.floor(Date.now()/1000)}`} alt="logo" className="toggle-logo" />
											<img src={`https://cloud.ultrastream.io/images/logo-us-large.png?d=${Math.floor(Date.now()/1000)}`} alt="logo" className="desktop-dark" />
											<img src={`https://cloud.ultrastream.io/images/logo-us.png?d=${Math.floor(Date.now()/1000)}`} alt="logo" className="toggle-dark" />
										</a>
									</div>
								</div>
										
								<div className="header-element">
									<a aria-label="anchor" href="#" onClick={()=>{openSidemenu()}} className="sidemenu-toggle header-link" data-bs-toggle="sidebar">
                    <span className="open-toggle me-2">
                      <i className="bx bx-menu header-link-icon"></i>
                    </span>
									</a>
									<div className="main-header-center  d-none d-lg-block  header-link">
										{/*<input type="text" className="form-control form-control-lg" id="typehead" placeholder="Search for results..." autocomplete="off" />
										<button type="button"  aria-label="button" className="btn pe-1"><i className="fe fe-search" aria-hidden="true"></i></button>
										<div id="headersearch" className="header-search">
											<div className="p-3">
												<div className="">
													<p className="fw-semibold text-muted mb-2 fs-13">Recent Searches</p>
													<div className="ps-2">
														<a  href="javascript:void(0)" className="search-tags"><i className="fe fe-search me-2"></i>People<span></span></a>
														<a  href="javascript:void(0)" className="search-tags"><i className="fe fe-search me-2"></i>Pages<span></span></a>
														<a  href="javascript:void(0)" className="search-tags"><i className="fe fe-search me-2"></i>Articles<span></span></a>
													</div>
												</div>
												<div className="mt-3">
													<p className="fw-semibold text-muted mb-2 fs-13">Apps and pages</p>
													<ul className="ps-2">
														<li className="p-1 d-flex align-items-center text-muted mb-2 search-app">
															<a href="https://laravelui.spruko.com/velvet/full-calendar"><span><i className="bx bx-calendar me-2 fs-14 bg-primary-transparent p-2 rounded-circle"></i>Calendar</span></a>
														</li>
														<li className="p-1 d-flex align-items-center text-muted mb-2 search-app">
															<a href="https://laravelui.spruko.com/velvet/mail"><span><i className="bx bx-envelope me-2 fs-14 bg-primary-transparent p-2 rounded-circle"></i>Mail</span></a>
														</li>
														<li className="p-1 d-flex align-items-center text-muted mb-2 search-app">
															<a href="https://laravelui.spruko.com/velvet/buttons"><span><i className="bx bx-dice-1 me-2 fs-14 bg-primary-transparent p-2 rounded-circle"></i>Buttons</span></a>
														</li>
													</ul>
												</div>
												<div className="mt-3">
													<p className="fw-semibold text-muted mb-2 fs-13">Links</p>
													<ul className="ps-2">
														<li className="p-1 align-items-center text-muted mb-1 search-app">
															<a href="javascript:void(0)" className="text-primary"><u>http://spruko/spruko.com</u></a>
														</li>
														<li className="p-1 align-items-center text-muted mb-1 search-app">
															<a href="javascript:void(0)" className="text-primary"><u>http://spruko/spruko.com</u></a>
														</li>
													</ul>
												</div>
											</div>
											<div className="py-3 border-top px-0">
												<div className="text-center">
													<a href="javascript:void(0)" className="text-primary text-decoration-underline fs-15">View all</a>
												</div>
											</div>
										</div>*/}
									</div>
								</div>
										
								{/*<div className="header-element header-search d-lg-none d-block ">
									<a aria-label="anchor" href="javascript:void(0);" className="header-link" data-bs-toggle="modal" data-bs-target="#searchModal">
										<i className="bx bx-search-alt-2 header-link-icon"></i>
									</a>
								</div>*/}

							</div>
							<div className="header-content-right">
								
								<div className="header-element header-theme-mode" style={{cursor: 'pointer'}}>
									<div className="header-link layout-setting" onClick={()=>changeMode()}>
										<i className="bx bx-sun bx-flip-horizontal header-link-icon ionicon  dark-layout"></i>
										<i className="bx bx-moon bx-flip-horizontal header-link-icon ionicon light-layout"></i>
										</div>
								</div>
								

										
								<div className="header-element cart-dropdown">
										
									<span className="header-link dropdown-toggle" onClick={()=>{toggleDropdown('cart')}} data-bs-toggle="dropdown" data-bs-auto-close="outside" style={{cursor: 'pointer'}}>
										<i className="bx bx-cart header-link-icon ionicon"></i>
										{cart.length > 0 &&<span className="badge bg-danger rounded-pill header-icon-badge" id="cart-icon-badge">{cart.length}</span>}
									</span>
										
									<div className={`main-header-dropdown dropdown-menu  border-0 dropdown-menu-end ${showDropdown==='cart'&&'show'}`} data-popper-placement={showDropdown==='cart'?'bottom-end':'none'} style={{
										position: 'absolute',
  									inset: '0px 0px auto auto',
  									margin: 0,
  									transform: 'translate(-188px, 65px)'
									}}>
										<div className="p-3">
											<div className="d-flex align-items-center justify-content-between">
												<p className="mb-0 fs-17 fw-semibold">Cart Items</p>
												<span className="badge bg-success-transparent" id="cart-data">{cart.length} Items</span>
											</div>
										</div>
										<div><hr className="dropdown-divider" /></div>
										<ul className="list-unstyled mb-0" id="header-cart-items-scroll">
											{cart.map((e, i) => {
												return (
													<li key ={i} className="dropdown-item border-bottom">
														<div className="d-flex align-items-start cart-dropdown-item">
															<span className="avatar avatar-xl bd-gray-200 p-1">
																<img src="https://laravelui.spruko.com/velvet/build/assets/images/ecommerce/png/1.png" alt="" />
															</span>
															<div className="flex-grow-1 ms-3">
																<div className="d-flex align-items-start justify-content-between mb-0">
																	<div className=" fs-13 fw-semibold">
																		<a href="https://ultrastream.io/radio">{e.product}</a>
																	</div>
																	<div>
																		<a aria-label="anchor" href="javascript:void(0);" className="header-cart-remove float-end dropdown-item-close"><i className="ti ti-trash"></i></a>
																	</div>
																</div>
																<div className="min-w-fit-content align-items-start">
																	{/*<div className=" fw-normal fs-12 text-muted">Quantity:02</div>*/}
																	<div className="d-flex  align-items-center">
																		<span className=" fw-semibold fs-16">£{e.choice === 'year' ? e.priceyear.toFixed(2) : e.pricemonth.toFixed(2)}</span>
																		<p className="text-muted ms-1 op-6 fs-12 mb-0">per {e.choice}</p>
																	</div>
																</div>
															</div>
														</div>
													</li>
												)
											})}
											
											{/*<li className="dropdown-item border-bottom">
												<div className="d-flex align-items-start cart-dropdown-item">
													<span className="avatar avatar-xl bd-gray-200 p-1">
														<img src="https://laravelui.spruko.com/velvet/build/assets/images/ecommerce/png/1.png" alt="" />
													</span>
													<div className="flex-grow-1 ms-3">
														<div className="d-flex align-items-start justify-content-between mb-0">
															<div className=" fs-13 fw-semibold">
																<a href="https://laravelui.spruko.com/velvet/cart">Cactus mini plant</a>
															</div>
															<div>
																<a aria-label="anchor" href="javascript:void(0);" className="header-cart-remove float-end dropdown-item-close"><i className="ti ti-trash"></i></a>
															</div>
														</div>
														<div className="min-w-fit-content align-items-start">
															<div className=" fw-normal fs-12 text-muted">Quantity:02</div>
															<div className="d-flex  align-items-center">
																<span className=" fw-semibold fs-16">$1,229</span>
																<p className="text-muted text-decoration-line-through ms-1 op-6 fs-12 mb-0">$1,799</p>
															</div>
														</div>
													</div>
												</div>
											</li>
											<li className="dropdown-item border-bottom">
												<div className="d-flex align-items-start cart-dropdown-item">
													<span className="avatar avatar-xl bd-gray-200 p-1">
														<img src="https://laravelui.spruko.com/velvet/build/assets/images/ecommerce/png/15.png" alt="" />
													</span>
													<div className="flex-grow-1 ms-3">
														<div className="d-flex align-items-start justify-content-between mb-0">
															<div className=" fs-13 fw-semibold">
																<a href="https://laravelui.spruko.com/velvet/cart">Sports shoes for men</a>
															</div>
															<div>
																<a aria-label="anchor" href="javascript:void(0);" className="header-cart-remove float-end dropdown-item-close"><i className="ti ti-trash"></i></a>
															</div>
														</div>
														<div className="min-w-fit-content align-items-start">
															<div className=" fw-normal fs-12 text-muted">Quantity:01</div>
															<div className="d-flex  align-items-center">
																<span className=" fw-semibold fs-16">$10,229</span>
																<p className="text-muted text-decoration-line-through ms-1 op-6 fs-12 mb-0">$799</p>
															</div>
														</div>
													</div>
												</div>
											</li>
											<li className="dropdown-item border-bottom">
												<div className="d-flex align-items-start cart-dropdown-item">
													<span className="avatar avatar-xl bd-gray-200 p-1">
														<img src="https://laravelui.spruko.com/velvet/build/assets/images/ecommerce/png/40.png" alt="" />
													</span>
													<div className="flex-grow-1 ms-3">
														<div className="d-flex align-items-start justify-content-between mb-0">
															<div className=" fs-13 fw-semibold">
																<a href="https://laravelui.spruko.com/velvet/cart">Pink color smart watch </a>
															</div>
															<div>
																<a aria-label="anchor" href="javascript:void(0);" className="header-cart-remove float-end dropdown-item-close"><i className="ti ti-trash"></i></a>
															</div>
														</div>
														<div className="min-w-fit-content align-items-start">
															<div className=" fw-normal fs-12 text-muted">Quantity:03</div>
															<div className="d-flex  align-items-center">
																<span className=" fw-semibold fs-16">$5,500</span>
																<p className="text-muted text-decoration-line-through ms-1 op-6 fs-12 mb-0">$599</p>
															</div>
														</div>
													</div>
												</div>
											</li>
											<li className="dropdown-item border-bottom">
												<div className="d-flex align-items-start cart-dropdown-item">
													<span className="avatar avatar-xl bd-gray-200 p-1">
														<img src="https://laravelui.spruko.com/velvet/build/assets/images/ecommerce/png/8.png" alt="" />
													</span>
													<div className="flex-grow-1 ms-3">
														<div className="d-flex align-items-start justify-content-between mb-0">
															<div className=" fs-13 fw-semibold">
																<a href="https://laravelui.spruko.com/velvet/cart">Red Leafs plant </a>
															</div>
															<div>
																<a aria-label="anchor" href="javascript:void(0);" className="header-cart-remove float-end dropdown-item-close"><i className="ti ti-trash"></i></a>
															</div>
														</div>
														<div className="min-w-fit-content align-items-start">
															<div className=" fw-normal fs-12 text-muted">Quantity:01</div>
															<div className="d-flex  align-items-center">
																<span className=" fw-semibold fs-16">$15,300</span>
																<p className="text-muted text-decoration-line-through ms-1 op-6 fs-12 mb-0">$799</p>
															</div>
														</div>
													</div>
												</div>
											</li>
											<li className="dropdown-item">
												<div className="d-flex align-items-start cart-dropdown-item">
													<span className="avatar avatar-xl bd-gray-200 p-1">
														<img src="https://laravelui.spruko.com/velvet/build/assets/images/ecommerce/png/11.png" alt="" />
													</span>
													<div className="flex-grow-1 ms-3">
														<div className="d-flex align-items-start justify-content-between mb-0">
															<div className=" fs-13 fw-semibold">
																<a href="https://laravelui.spruko.com/velvet/cart">Good luck mini plant</a>
															</div>
															<div>
																<a aria-label="anchor" href="javascript:void(0);" className="header-cart-remove float-end dropdown-item-close"><i className="ti ti-trash"></i></a>
															</div>
														</div>
														<div className="min-w-fit-content align-items-start">
															<div className=" fw-normal fs-12 text-muted">Quantity:02</div>
															<div className="d-flex  align-items-center">
																<span className=" fw-semibold fs-16">$600</span>
																<p className="text-muted text-decoration-line-through ms-1 op-6 fs-12 mb-0">$99</p>
															</div>
														</div>
													</div>
												</div>
											</li>*/}
										</ul>
										<div className="p-3 empty-header-item border-top">
											<div className="d-grid">
												<Link to={'/cart'} className="btn btn-primary">Checkout</Link>
											</div>
										</div>
										<div className="p-5 empty-item d-none">
											<div className="text-center">
												<span className="avatar avatar-xxl avatar-rounded bg-warning-transparent">
													<i className="bx bx-cart bx-tada fs-2"></i>
												</span>
												<h6 className="fw-bold mb-2 mt-3">Your Cart is Empty</h6>
												<a href="https://laravelui.spruko.com/velvet/products" className="btn btn-primary btn-wave btn-sm m-1" data-abc="true">continue shopping <i className="bi bi-arrow-right ms-1"></i></a>
											</div>
										</div>
									</div>
										
								</div>
										

										
								<div className="header-element notifications-dropdown ">
										
									<span className="header-link dropdown-toggle" onClick={()=>{toggleDropdown('notification')}} data-bs-toggle="dropdown" data-bs-auto-close="outside" id="messageDropdown" aria-expanded="false" style={{cursor: 'pointer'}}>
										<i className="bx bx-bell bx-flip-horizontal header-link-icon ionicon"></i>
										{/*<span className="badge bg-info rounded-pill header-icon-badge pulse pulse-secondary" id="notification-icon-badge">0</span>*/}
									</span>
										
										
									<div className={`main-header-dropdown dropdown-menu  border-0 ${showDropdown==='notification'&&'show'}`} data-popper-placement={showDropdown==='notification'?'bottom-end':'none'} style={{
										position: 'absolute',
  									inset: '0px 0px auto auto',
  									margin: 0,
  									transform: 'translate(-146px, 65px)'
									}}>
										<div className="p-3">
											<div className="d-flex align-items-center justify-content-between">
												<p className="mb-0 fs-17 fw-semibold">Notifications</p>
												<span className="badge bg-secondary-transparent" id="notifiation-data">0 Unread</span>
											</div>
										</div>
										<div className="dropdown-divider"></div>
											<ul className="list-unstyled mb-0" id="header-notification-scroll">
												{/*<li className="dropdown-item">
													<div className="d-flex align-items-start">
														<div className="pe-2">
															<span className="avatar avatar-md bg-secondary-transparent rounded-2">
																<img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/2.jpg" alt="" />
															</span>
														</div>
														<div className="flex-grow-1 d-flex  justify-content-between">
															<div>
																<p className="mb-0 fw-semibold"><a href="https://laravelui.spruko.com/velvet/notifications">Olivia James</a></p>
																<span className="fs-12 text-muted fw-normal">Congratulate for New template start</span>
															</div>
															<div className="min-w-fit-content ms-2 text-end">
																<a aria-label="anchor" href="javascript:void(0);" className="min-w-fit-content text-muted me-1 dropdown-item-close1"><i className="ti ti-x fs-14"></i></a>
																<p className="mb-0 text-muted fs-11">2 min ago</p>
															</div>
														</div>
													</div>
												</li>
												<li className="dropdown-item">
													<div className="d-flex align-items-start">
														<div className="pe-2">
															<span className="avatar avatar-md bg-warning-transparent rounded-2"><i className="bx bx-pyramid fs-18"></i></span>
														</div>
														<div className="flex-grow-1 d-flex  justify-content-between">
															<div>
																<p className="mb-0 fw-semibold"><a href="https://laravelui.spruko.com/velvet/notifications">Order Placed <span className="text-warning">ID: #1116773</span></a></p>
																<span className="fs-12 text-muted fw-normal header-notification-text">Order Placed Successfully</span>
															</div>
															<div className="min-w-fit-content ms-2 text-end">
																<a aria-label="anchor" href="javascript:void(0);" className="min-w-fit-content text-muted me-1 dropdown-item-close1"><i className="ti ti-x fs-14"></i></a>
																<p className="mb-0 text-muted fs-11">5 min ago</p>
															</div>
														</div>
													</div>
												</li>
												<li className="dropdown-item">
													<div className="d-flex align-items-start">
														<div className="pe-2">
															<span className="avatar avatar-md bg-secondary-transparent rounded-2">
																<img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/8.jpg" alt="" />
															</span>
														</div>
														<div className="flex-grow-1 d-flex  justify-content-between">
															<div>
																<p className="mb-0 fw-semibold"><a href="https://laravelui.spruko.com/velvet/notifications">Elizabeth Lewis</a></p>
																<span className="fs-12 text-muted fw-normal">added new schedule realease date</span>
															</div>
															<div className="min-w-fit-content ms-2 text-end">
																<a aria-label="anchor" href="javascript:void(0);" className="min-w-fit-content text-muted me-1 dropdown-item-close1"><i className="ti ti-x fs-14"></i></a>
																<p className="mb-0 text-muted fs-11">10 min ago</p>
															</div>
														</div>
													</div>
												</li>
												<li className="dropdown-item">
													<div className="d-flex align-items-start">
														<div className="pe-2">
															<span className="avatar avatar-md bg-primary-transparent rounded-2"><i className="bx bx-pulse fs-18"></i></span>
														</div>
														<div className="flex-grow-1 d-flex  justify-content-between">
															<div>
																<p className="mb-0 fw-semibold"><a href="https://laravelui.spruko.com/velvet/notifications">Your Order Has Been Shipped</a></p>
																<span className="fs-12 text-muted fw-normal header-notification-text">Order No: 123456 Has Shipped To Your Delivery Address</span>
															</div>
															<div className="min-w-fit-content ms-2 text-end">
																<a aria-label="anchor" href="javascript:void(0);" className="min-w-fit-content text-muted me-1 dropdown-item-close1"><i className="ti ti-x fs-14"></i></a>
																<p className="mb-0 text-muted fs-11">12 min ago</p>
															</div>
														</div>
													</div>
												</li>
												<li className="dropdown-item">
													<div className="d-flex align-items-start">
														<div className="pe-2">
															<span className="avatar avatar-md bg-pink-transparent rounded-2"><i className="bx bx-badge-check"></i></span>
														</div>
														<div className="flex-grow-1 d-flex  justify-content-between">
															<div>
																<p className="mb-0 fw-semibold"><a href="https://laravelui.spruko.com/velvet/notifications">Account Has Been Verified</a></p>
																<span className="fs-12 text-muted fw-normal  header-notification-text">Your Account Has Been Verified Sucessfully</span>
															</div>
															<div className="min-w-fit-content ms-2 text-end">
																<a aria-label="anchor" href="javascript:void(0);" className="min-w-fit-content text-muted me-1 dropdown-item-close1"><i className="ti ti-x fs-14"></i></a>
																<p className="mb-0 text-muted fs-11">20 min ago</p>
															</div>
														</div>
													</div>
												</li>*/}
											</ul>
											<div className="p-3 empty-header-item1 border-top">
												<div className="d-grid">
													<Link to={"/notifications"} className="btn btn-primary">View All</Link>
												</div>
											</div>
											<div className="p-5 empty-item1 d-none">
												<div className="text-center">
													<span className="avatar avatar-xl avatar-rounded bg-secondary-transparent">
														<i className="bx bx-bell-off bx-tada fs-2"></i>
													</span>
													<h6 className="fw-semibold mt-3">No New Notifications</h6>
												</div>
											</div>
										</div>
											
									</div>
											
												
									<div className="d-flex header-settings">
										<span aria-label="anchor" onClick={()=>{toggleDropdown('offcanvas')}} className=" header-link nav-link icon me-1" data-bs-toggle="offcanvas" data-bs-target="#sidebar-right" aria-controls="sidebar-right" style={{cursor: 'pointer'}}>
											<i className="bx bx-slider header-link-icon"></i>
										</span>
									</div>
											

									<Dropdown className="header-element mainuserProfile">
										<Dropdown.Toggle as={CustomToggle} id="dropdown-button-dark-example1">
											<div className="d-flex align-items-center">
												<div className="d-sm-flex wd-100p">
													<div className="avatar avatar-sm"><img alt="avatar" className="rounded-circle" src={`https://cloud.ultrastream.io${user.user.avatar}`} /></div>
													<div className="ms-2 my-auto d-none d-xl-flex">
														<h6 className=" font-weight-semibold mb-0 fs-13 user-name d-sm-block d-none">{user.user.title?user.user.title:user.user.username}</h6>
													</div>
												</div>
											</div>
										</Dropdown.Toggle>
										<Dropdown.Menu as={CustomMenu}>
											<Dropdown.Item eventKey="1" as={Link} to={`/profile/${user.user.username}`}><i className="fs-13 me-2 bx bx-user"></i>Profile</Dropdown.Item>
											{user?.admin?.owner &&
												<Dropdown.Item eventKey="2" as={Link} to="/messages"><i className="fs-13 me-2 bx bx-comment"></i>Message</Dropdown.Item>
											}
											<Dropdown.Item eventKey="3" as={Link} to="/invoices"><i className="fs-13 me-2 bx bx-comment"></i>invoices</Dropdown.Item>
											<Dropdown.Item eventKey="4" as={Link} to="/settings"><i className="fs-13 me-2 bx bx-cog"></i>Settings</Dropdown.Item>
											{user?.admin?.owner &&
												<Dropdown.Item eventKey="5" as={Link} to="/news"><i className="fs-13 me-2 bx bx-help-circle"></i>Help</Dropdown.Item>
											}
											<Dropdown.Item eventKey="6" as={Link} to="/logout"><i className="fs-13 me-2 bx bx-arrow-to-right"></i>Log Out</Dropdown.Item>
										</Dropdown.Menu>
									</Dropdown>
											
							</div>
						</div>
					</header>

					<aside className="app-sidebar" id="sidebar" onMouseEnter={()=>toggleSidemenu(true)} onMouseLeave={()=>toggleSidemenu(false)}>

                
                <div className="main-sidebar-header">
                    <a href={process.env.NODE_ENV==="production"?"/":"https://laravelui.spruko.com/velvet/index"} className="header-logo"> 
                        <img src={`https://cloud.ultrastream.io/images/logo-us-large.png?d=${Math.floor(Date.now()/1000)}`} alt="logo" className="desktop-logo" />
                        <img src={`https://cloud.ultrastream.io/images/logo-us.png?d=${Math.floor(Date.now()/1000)}`} alt="logo" className="toggle-logo" />
                        <img src={`https://cloud.ultrastream.io/images/logo-us-large.png?d=${Math.floor(Date.now()/1000)}`} alt="logo" className="desktop-dark" />
                        <img src={`https://cloud.ultrastream.io/images/logo-us.png?d=${Math.floor(Date.now()/1000)}`} alt="logo" className="toggle-dark" />
                    </a>
                </div>
                
                <div className="main-sidebar" id="sidebar-scroll">

                    
                    <nav className="main-menu-container nav nav-pills flex-column sub-open" onClick={()=>closeSidebar()}>
                        <div className="slide-left" id="slide-left">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24"> <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path> </svg>
                        </div>
                        <ul className="main-menu">
                            
                            <li className="slide__category"><span className="category-name">Main</span></li>
                            
                            <li className="slide has-sub">
                              <Link to="/" className={`side-menu__item ${page.parent===''?'active':''}`}>
                                <span className=" side-menu__icon">
                                  <i className='bx bx-desktop'></i>
                                </span>
                                <span className="side-menu__label">Dashboard{/*<span className="badge bg-warning-transparent ms-2 d-inline-block">12</span>*/}</span>
                                <i className="fe fe-chevron-right side-menu__angle"></i>
                              </Link>
                            </li>

                            <li className="slide has-sub">
                              <Link to="/streamkey" className={`side-menu__item ${page.parent==='streamkey'?'active':''}`}>
                                <span className=" side-menu__icon">
                                  <i className='bx bx-key'></i>
                                </span>
                                <span className="side-menu__label">Stream Key</span>
                                <i className="fe fe-chevron-right side-menu__angle"></i>
                              </Link>
                            </li>
														{user?.admin?.owner &&
                            	<>
																<li className="slide has-sub">
																	<Link to="/news" className={`side-menu__item ${page.parent===''?'news':''}`}>
																		<span className=" side-menu__icon">
																			<i className='bx bx-news'></i>
																		</span>
																		<span className="side-menu__label">News</span>
																		<i className="fe fe-chevron-right side-menu__angle"></i>
																	</Link>
																</li>
																<li className="slide has-sub">
																	<Link to="/docs" className={`side-menu__item ${page.parent===''?'docs':''}`}>
																		<span className=" side-menu__icon">
																			<i className='bx bx-help-circle'></i>
																		</span>
																		<span className="side-menu__label">Docs</span>
																		<i className="fe fe-chevron-right side-menu__angle"></i>
																	</Link>
																</li>
															</>
														}


                            {services.map(service => (
                              <React.Fragment key={service.id}>

																{/*---- All ----*/}
																<SidemenuHeader service={service} />
																

																{/*---- Sinlge Streamer -----*/}
																{(service.pid >= 1 || service.pid < 10) &&
																	<>
																	</>
																}

																{/*---- EmojiCrew -----*/}
																{(service.pid >= 10 || service.pid < 20) &&
																	<>
																	</>
																}

																{/*---- Radio Management -----*/}
																{(service.pid >= 20 || service.pid < 30) &&
																	<>
																		<SidemenuLiveStream service={service} />
																		<SidemenuSchedule service={service} />
																		{user?.admin?.owner &&
																			<>
																			<SidemenuEmojiCrew service={service} />
																			<SidemenuAnalytics service={service} />
																			</>
																		}
																		<SidemenuDropsJingles service={service} />
																		<SidemenuReplays service={service} />

																		{service?.admin === true &&
																			<>
																				<SidemenuAdmin service={service} />
																				<SidemenuInvites service={service} />
																				<SidemenuDJAccounts service={service} />
																				<SidemenuPlatforms service={service} />
																				<SidemenuDiscord service={service} />
																				<SidemenuEmbeds service={service} />
																				{/*<SidemenuOrganiser service={service} />
																				<SidemenuVideos service={service} />*/}
																			</>
																		}


																	</>
																}

																{/*---- Dedicated Radio Management -----*/}
																{(service.pid >= 30 || service.pid < 40) &&
																	<>
																	</>
																}

                                

                                

																{(service.pid < 10 || service.pid >= 20) &&
																	<>
																		
																	</>
																}

																{/*service.pid < 10  &&
																	<>
																		<li className="slide has-sub">
                                      <Link to={`/${service.id}/loadout`} className="side-menu__item">
                                        <span className=" side-menu__icon">
                                          <i className='bx bx-cube'></i>
                                        </span>
                                        <span className="side-menu__label">Stream Loadout</span>
                                        <i className="fe fe-chevron-right side-menu__angle"></i>
                                      </Link>
                                    </li>
																	</>
																}

																{//service.pid >= 10 && service.pid < 20 &&
																	<>
																		<li className="slide has-sub">
                                      <Link to={`/${service.id}/authentication`} className="side-menu__item">
                                        <span className=" side-menu__icon">
                                          <i className='bx bx-cube'></i>
                                        </span>
                                        <span className="side-menu__label">Authentication</span>
                                        <i className="fe fe-chevron-right side-menu__angle"></i>
                                      </Link>
                                    </li>
																		
																	</>
																*/}

                                {service.pid >= 20 && service.pid < 40 &&
                                  <>
                                    

                                    

                                    {/*<li className="slide__category"><span className="category-name">Admin</span></li>}

                                    <li className="slide has-sub">
                                      <Link to={`/${service.id}/overview`} className="side-menu__item">
                                        <span className=" side-menu__icon">
                                          <i className='bx bx-cube'></i>
                                        </span>
                                        <span className="side-menu__label">Overview</span>
                                        <i className="fe fe-chevron-right side-menu__angle"></i>
                                      </Link>
                                    </li>

                                    <li className="slide has-sub">
                                      <Link to={`/${service.id}/clients`} className="side-menu__item">
                                        <span className=" side-menu__icon">
                                          <i className='bx bx-cube'></i>
                                        </span>
                                        <span className="side-menu__label">DJ Accounts</span>
                                        <i className="fe fe-chevron-right side-menu__angle"></i>
                                      </Link>
                                    </li>

                                    <li className="slide has-sub">
                                      <Link to={`/${service.id}/organiser`} className="side-menu__item">
                                        <span className=" side-menu__icon">
                                          <i className='bx bx-cube'></i>
                                        </span>
                                        <span className="side-menu__label">Schedule Organiser</span>
                                        <i className="fe fe-chevron-right side-menu__angle"></i>
                                      </Link>
                                    </li>

                                    <li className="slide has-sub">
                                      <Link to={`/${service.id}/`} className="side-menu__item">
                                        <span className=" side-menu__icon">
                                          <i className='bx bx-cube'></i>
                                        </span>
                                        <span className="side-menu__label">{service.title}</span>
                                        <i className="fe fe-chevron-right side-menu__angle"></i>
                                      </Link>
                                    </li>*/}
                                  </>
                                }


                              </React.Fragment>
                            ))}
                            
                        </ul>
                        <div className="slide-right" id="slide-right"><svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24"> <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path> </svg></div>
                    </nav>

                </div>

            </aside>

						<div id="responsive-overlay" className={active===true?'active':''} onClick={()=>closeSidebar()}></div>


						<Offcanvas show={showDropdown==='offcanvas'?true:false} onHide={()=>setDropdown(false)} placement={'end'}>
        			<div className="offcanvas-body position-relative">

								<div className="d-sm-flex d-block">

									<Nav variant="pills" defaultActiveKey="orders-1">
										<Nav.Item>
											<Nav.Link data-bs-target="orders-1" eventKey="orders-1"><i className="bx bx-user-plus me-1 fs-16 align-middle"></i> Team</Nav.Link>
										</Nav.Item>
										<Nav.Item>
											<Nav.Link data-bs-target="accepted-1" eventKey="accepted-1"><i className="bx bx-pulse me-1 fs-16 align-middle"></i>Timeline</Nav.Link>
										</Nav.Item>
										<Nav.Item>
											<Nav.Link data-bs-target="declined-1" eventKey="declined-1"><i className="bx bx-message-square-dots me-1 fs-16 align-middle"></i>Chat</Nav.Link>
										</Nav.Item>
									</Nav>
									<div className="ms-auto my-auto">
										<button type="button" className="btn-close"  aria-label="Close" onClick={()=>setDropdown(false)}></button>
									</div>
								</div>
								
								

								<div className="tab-content">
										<div className="tab-pane active" id="orders-1" role="tabpanel">
												<div className="card-body p-0">
														<input type="text" className="form-control flatpickr-input" id="inlinecalendar" placeholder="Choose date" readonly="readonly" />
														<div className="flatpickr-calendar animate inline" tabindex="-1">
																<div className="flatpickr-months"><span className="flatpickr-prev-month"><svg version="1.1" viewBox="0 0 17 17"><g></g><path d="M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z"></path></svg></span>
																		<div
																				className="flatpickr-month">
																				<div className="flatpickr-current-month"><select className="flatpickr-monthDropdown-months" aria-label="Month" tabindex="-1"><option className="flatpickr-monthDropdown-month" value="0" tabindex="-1">January</option><option className="flatpickr-monthDropdown-month" value="1" tabindex="-1">February</option><option className="flatpickr-monthDropdown-month" value="2" tabindex="-1">March</option><option className="flatpickr-monthDropdown-month" value="3" tabindex="-1">April</option><option className="flatpickr-monthDropdown-month" value="4" tabindex="-1">May</option><option className="flatpickr-monthDropdown-month" value="5" tabindex="-1">June</option><option className="flatpickr-monthDropdown-month" value="6" tabindex="-1">July</option><option className="flatpickr-monthDropdown-month" value="7" tabindex="-1">August</option><option className="flatpickr-monthDropdown-month" value="8" tabindex="-1">September</option><option className="flatpickr-monthDropdown-month" value="9" tabindex="-1">October</option><option className="flatpickr-monthDropdown-month" value="10" tabindex="-1">November</option><option className="flatpickr-monthDropdown-month" value="11" tabindex="-1">December</option></select>
																						<div
																								className="numInputWrapper"><input className="numInput cur-year" type="number" tabindex="-1" aria-label="Year" /><span className="arrowUp"></span><span className="arrowDown"></span></div>
																</div>
														</div><span className="flatpickr-next-month"><svg version="1.1" viewBox="0 0 17 17"><g></g><path d="M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z"></path></svg></span></div>
												<div
														className="flatpickr-innerContainer">
														<div className="flatpickr-rContainer">
																<div className="flatpickr-weekdays">
																		<div className="flatpickr-weekdaycontainer">
																				<span className="flatpickr-weekday">
										Sun</span><span className="flatpickr-weekday">Mon</span><span className="flatpickr-weekday">Tue</span><span className="flatpickr-weekday">Wed</span><span className="flatpickr-weekday">Thu</span><span className="flatpickr-weekday">Fri</span>
																				<span
																						className="flatpickr-weekday">Sat
																						</span>
																		</div>
																</div>
																<div className="flatpickr-days" tabindex="-1">
																		<div className="dayContainer"><span className="flatpickr-day" aria-label="June 1, 2025" tabindex="-1">1</span><span className="flatpickr-day" aria-label="June 2, 2025" tabindex="-1">2</span><span className="flatpickr-day" aria-label="June 3, 2025" tabindex="-1">3</span>
																				<span
																						className="flatpickr-day" aria-label="June 4, 2025" tabindex="-1">4</span><span className="flatpickr-day" aria-label="June 5, 2025" tabindex="-1">5</span><span className="flatpickr-day" aria-label="June 6, 2025" tabindex="-1">6</span><span className="flatpickr-day" aria-label="June 7, 2025" tabindex="-1">7</span>
																						<span
																								className="flatpickr-day" aria-label="June 8, 2025" tabindex="-1">8</span><span className="flatpickr-day" aria-label="June 9, 2025" tabindex="-1">9</span><span className="flatpickr-day" aria-label="June 10, 2025" tabindex="-1">10</span><span className="flatpickr-day" aria-label="June 11, 2025" tabindex="-1">11</span>
																								<span
																										className="flatpickr-day" aria-label="June 12, 2025" tabindex="-1">12</span><span className="flatpickr-day" aria-label="June 13, 2025" tabindex="-1">13</span><span className="flatpickr-day today selected" aria-label="June 14, 2025" aria-current="date" tabindex="-1">14</span><span className="flatpickr-day"
																												aria-label="June 15, 2025" tabindex="-1">15</span><span className="flatpickr-day" aria-label="June 16, 2025" tabindex="-1">16</span><span className="flatpickr-day" aria-label="June 17, 2025" tabindex="-1">17</span>
																										<span
																												className="flatpickr-day" aria-label="June 18, 2025" tabindex="-1">18</span><span className="flatpickr-day" aria-label="June 19, 2025" tabindex="-1">19</span><span className="flatpickr-day" aria-label="June 20, 2025" tabindex="-1">20</span><span className="flatpickr-day" aria-label="June 21, 2025"
																														tabindex="-1">21</span><span className="flatpickr-day" aria-label="June 22, 2025" tabindex="-1">22</span><span className="flatpickr-day" aria-label="June 23, 2025" tabindex="-1">23</span><span className="flatpickr-day"
																														aria-label="June 24, 2025" tabindex="-1">24</span><span className="flatpickr-day" aria-label="June 25, 2025" tabindex="-1">25</span><span className="flatpickr-day" aria-label="June 26, 2025" tabindex="-1">26</span>
																												<span
																														className="flatpickr-day" aria-label="June 27, 2025" tabindex="-1">27</span><span className="flatpickr-day" aria-label="June 28, 2025" tabindex="-1">28</span><span className="flatpickr-day" aria-label="June 29, 2025" tabindex="-1">29</span><span className="flatpickr-day" aria-label="June 30, 2025"
																																tabindex="-1">30</span><span className="flatpickr-day nextMonthDay" aria-label="July 1, 2025" tabindex="-1">1</span><span className="flatpickr-day nextMonthDay" aria-label="July 2, 2025" tabindex="-1">2</span>
																														<span
																																className="flatpickr-day nextMonthDay" aria-label="July 3, 2025" tabindex="-1">3</span><span className="flatpickr-day nextMonthDay" aria-label="July 4, 2025" tabindex="-1">4</span><span className="flatpickr-day nextMonthDay" aria-label="July 5, 2025" tabindex="-1">5</span><span className="flatpickr-day nextMonthDay"
																																		aria-label="July 6, 2025" tabindex="-1">6</span><span className="flatpickr-day nextMonthDay" aria-label="July 7, 2025" tabindex="-1">7</span><span className="flatpickr-day nextMonthDay" aria-label="July 8, 2025"
																																		tabindex="-1">8</span><span className="flatpickr-day nextMonthDay" aria-label="July 9, 2025" tabindex="-1">9</span><span className="flatpickr-day nextMonthDay" aria-label="July 10, 2025" tabindex="-1">10</span>
																																<span
																																		className="flatpickr-day nextMonthDay" aria-label="July 11, 2025" tabindex="-1">11</span><span className="flatpickr-day nextMonthDay" aria-label="July 12, 2025" tabindex="-1">12</span></div>
																</div>
														</div>
										</div>
								</div>
						</div>
						<div className="d-flex pt-4 mt-3 pb-3 align-items-center">
								<div>
										<h6 className="fw-semibold mb-0">Team Members</h6>
								</div>
								<div className="ms-auto">
										<div className="dropdown">
												<a href="javascript:void(0);" className="btn-outline-light btn btn-sm text-muted" data-bs-toggle="dropdown" aria-expanded="false">
																												View All<i className="ri-arrow-down-s-line align-middle ms-1"></i>
																										</a>
												<ul className="dropdown-menu" role="menu">
														<li className="border-bottom"><a className="dropdown-item" href="javascript:void(0);">Today</a>
														</li>
														<li className="border-bottom"><a className="dropdown-item" href="javascript:void(0);">This
																																Week</a></li>
														<li><a className="dropdown-item" href="javascript:void(0);">Last Week</a></li>
												</ul>
										</div>
								</div>
						</div>
						<ul className="ps-0 vertical-scroll">
								<li className="item">
										<div className="rounded-2 p-3 border mb-2">
												<div className="d-flex">
														<a href="https://laravelui.spruko.com/velvet/profile"><img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/16.jpg" alt="img" className="avatar avatar-md rounded-2 me-3" /></a>
														<div className="me-3">
																<a href="https://laravelui.spruko.com/velvet/profile">
																		<h6 className="mb-0 fw-semibold text-default">Vanessa James</h6>
																</a>
																<span className="clearfix"></span>
																<span className="fs-12 text-muted">Front-end Developer</span>
														</div>
														<a aria-label="anchor" href="javascript:void(0);" className="ms-auto my-auto"> <i className="ri-arrow-right-s-line text-muted fs-20"></i></a>
												</div>
										</div>
								</li>
								<li className="item">
										<div className="rounded-2 p-3 border mb-2">
												<div className="d-flex">
														<a href="https://laravelui.spruko.com/velvet/profile"><span className="avatar avatar-md rounded-2 bg-primary-transparent text-primary me-3">KH</span></a>
														<div className="me-3">
																<a href="https://laravelui.spruko.com/velvet/profile">
																		<h6 className="mb-0 fw-semibold text-default">Kriti Harris</h6>
																</a>
																<span className="clearfix"></span>
																<span className="fs-12 text-muted">Back-end Developer</span>
														</div>
														<a aria-label="anchor" href="javascript:void(0);" className="ms-auto my-auto"> <i className="ri-arrow-right-s-line text-muted fs-20"></i></a>
												</div>
										</div>
								</li>
								<li className="item">
										<div className="rounded-2 p-3 border mb-2">
												<div className="d-flex">
														<a href="https://laravelui.spruko.com/velvet/profile"><img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/6.jpg" alt="img" className="avatar avatar-md rounded-2 me-3" /></a>
														<div className="me-3">
																<a href="https://laravelui.spruko.com/velvet/profile">
																		<h6 className="mb-0 fw-semibold text-default">Mira Henry</h6>
																</a>
																<span className="clearfix"></span>
																<span className="fs-12 text-muted">UI / UX Designer</span>
														</div>
														<a aria-label="anchor" href="javascript:void(0);" className="ms-auto my-auto"> <i className="ri-arrow-right-s-line text-muted fs-20"></i></a>
												</div>
										</div>
								</li>
								<li className="item">
										<div className="rounded-2 p-3 border mb-2">
												<div className="d-flex">
														<a href="https://laravelui.spruko.com/velvet/profile"><span className="avatar avatar-md rounded-2 bg-secondary-transparent text-secondary me-3">JK</span></a>
														<div className="me-3">
																<a href="https://laravelui.spruko.com/velvet/profile">
																		<h6 className="mb-0 fw-semibold text-default">James Kimberly</h6>
																</a>
																<span className="clearfix"></span>
																<span className="fs-12 text-muted">Angular Developer</span>
														</div>
														<a aria-label="anchor" href="javascript:void(0);" className="ms-auto my-auto"> <i className="ri-arrow-right-s-line text-muted fs-20"></i></a>
												</div>
										</div>
								</li>
								<li className="item">
										<div className="rounded-2 p-3 border mb-2">
												<div className="d-flex">
														<a href="https://laravelui.spruko.com/velvet/profile"><img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/9.jpg" alt="img" className="avatar avatar-md rounded-2 me-3" /></a>
														<div className="me-3">
																<a href="https://laravelui.spruko.com/velvet/profile">
																		<h6 className="mb-0 fw-semibold text-default">Marley Paul</h6>
																</a>
																<span className="clearfix"></span>
																<span className="fs-12 text-muted">Front-end Developer</span>
														</div>
														<a aria-label="anchor" href="javascript:void(0);" className="ms-auto my-auto"> <i className="ri-arrow-right-s-line text-muted fs-20"></i></a>
												</div>
										</div>
								</li>
								<li className="item">
										<div className="rounded-2 p-3 border mb-2">
												<div className="d-flex">
														<a href="https://laravelui.spruko.com/velvet/profile"><span className="avatar avatar-md rounded-2 bg-success-transparent text-success me-3">MA</span></a>
														<div className="me-3">
																<a href="https://laravelui.spruko.com/velvet/profile">
																		<h6 className="mb-0 fw-semibold text-default">Mitrona Anna</h6>
																</a>
																<span className="clearfix"></span>
																<span className="fs-12 text-muted">UI / UX Designer</span>
														</div>
														<a aria-label="anchor" href="javascript:void(0);" className="ms-auto my-auto"> <i className="ri-arrow-right-s-line text-muted fs-20"></i></a>
												</div>
										</div>
								</li>
						</ul>
						</div>
						<div className="tab-pane" id="accepted-1" role="tabpanel">
								<ul className="activity-list">
										<li className="d-flex mt-4">
												<div>
														<i className="activity-icon">
																												<a href="https://laravelui.spruko.com/velvet/profile"><img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/14.jpg" alt="img" className="avatar avatar-xs rounded-2 me-3" /></a>
																										</i>
														<a href="https://laravelui.spruko.com/velvet/profile">
																<h6 className="text-default">Elmer Barnes
																		<span className="text-muted fs-11 mx-2 fw-normal">Today 02:41 PM</span>
																</h6>
														</a>
														<p className="text-muted fs-12 mb-0">Added 1 attachment <strong>docfile.doc</strong></p>
														<div className="btn-group file-attach mt-3" role="group" aria-label="Basic example">
																<button type="button" className="btn btn-sm btn-primary-light">
																														<span className="ri-file-line me-2"></span> Image_file.jpg
																												</button>
																<button type="button" className="btn btn-sm btn-primary-light" aria-label="Close">
																														<span className="ri-download-2-line"></span>
																												</button>
														</div>
												</div>
										</li>
										<li className="d-flex mt-4">
												<div>
														<i className="activity-icon">
																												<span className="avatar avatar-xs brround bg-success">RN</span>
																										</i>
														<a href="https://laravelui.spruko.com/velvet/profile">
																<h6 className="text-default">Roxanne Nunez
																		<span className="text-muted fs-11 mx-2 fw-normal">Today 11:40 AM</span>
																</h6>
														</a>
														<p className="text-muted fs-12 mb-0">Commented on <strong>Task Management</strong></p>
														<div className="activity-comment mt-3">
																<p>There are many variations of passages of Lorem Ipsum available.</p>
														</div>
												</div>
										</li>
										<li className="d-flex mt-4">
												<div>
														<i className="activity-icon">
																												<span className="avatar avatar-xs brround bg-primary"><i className="ri-shield-line text-white"></i></span>
														</i>
														<a href="https://laravelui.spruko.com/velvet/profile">
																<h6 className="text-default">Shirley Vega
																		<span className="text-muted fs-11 mx-2 fw-normal">Today 08:43 AM</span>
																</h6>
														</a>
														<p className="text-muted fs-12 mb-0">Task Closed by <strong> Today</strong></p>
												</div>
										</li>
										<li className="d-flex mt-4">
												<div>
														<i className="activity-icon">
																												<a href="https://laravelui.spruko.com/velvet/profile"><img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/11.jpg" alt="img" className="avatar avatar-xs rounded-2 me-3" /></a>
																										</i>
														<a href="https://laravelui.spruko.com/velvet/profile">
																<h6 className="text-default">Vivian Herrera
																		<span className="text-muted fs-11 mx-2 fw-normal">Today 08:00 AM</span>
																</h6>
														</a>
														<p className="text-muted fs-12 mb-0">Assigned a new Task on <strong> UI Design</strong></p>
												</div>
										</li>
										<li className="d-flex mt-4">
												<div>
														<i className="activity-icon">
																												<span className="avatar avatar-xs brround bg-success">TJ</span>
																										</i>
														<a href="https://laravelui.spruko.com/velvet/profile">
																<h6 className="text-default">Tony Jarvis
																		<span className="text-muted fs-11 mx-2 fw-normal">Yesterday 05:40 PM</span>
																</h6>
														</a>
														<p className="text-muted fs-12 mb-0">Added 3 attachments <strong>Project</strong></p>
														<div className="activity-images mt-3">
																<a href="https://laravelui.spruko.com/velvet/gallery"><img src="https://laravelui.spruko.com/velvet/build/assets/images/media/media-34.jpg" alt="thumb1" /></a>
																<a href="https://laravelui.spruko.com/velvet/gallery"><img src="https://laravelui.spruko.com/velvet/build/assets/images/media/media-35.jpg" alt="thumb1" /></a>
																<a href="https://laravelui.spruko.com/velvet/gallery"><img src="https://laravelui.spruko.com/velvet/build/assets/images/media/media-36.jpg" alt="thumb1" /></a>
														</div>
												</div>
										</li>
										<li className="d-flex mt-4">
												<div>
														<i className="activity-icon">
																												<a href="https://laravelui.spruko.com/velvet/profile"><img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/16.jpg" alt="img" className="avatar avatar-xs rounded-2 me-3" /></a>
																										</i>
														<a href="https://laravelui.spruko.com/velvet/profile">
																<h6 className="text-default">Russell Kim
																		<span className="text-muted fs-11 mx-2 fw-normal">17 May 2022</span>
																</h6>
														</a>
														<p className="text-muted fs-12 mb-0">Created a group <strong> Team Unity</strong></p>
												</div>
										</li>
								</ul>
						</div>
						<div className="tab-pane" id="declined-1" role="tabpanel">
								<div className="list-group list-group-flush">
										<div className="pt-3 fw-semibold ps-2 text-muted">Today</div>
										<div className="list-group-item d-flex align-items-center">
												<div className="me-2">
														<a href="https://laravelui.spruko.com/velvet/profile"><img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/16.jpg" alt="img" className="avatar avatar-md rounded-2" /></a>
												</div>
												<div className="">
														<a href="https://laravelui.spruko.com/velvet/chat">
																<h6 className="fw-semibold mb-0">Leon Ray</h6>
																<p className="mb-0 fs-12 text-muted"> 2 mins ago </p>
														</a>
												</div>
												<div className="ms-auto">
														<a aria-label="anchor" href="javascript:void(0);" className="btn btn-sm btn-outline-light  me-1"><i className="ri-phone-line text-success"></i></a>
														<a aria-label="anchor" href="javascript:void(0);" className="btn btn-sm btn-outline-light"><i className="ri-chat-3-line text-primary"></i></a>
												</div>
										</div>
										<div className="list-group-item d-flex align-items-center">
												<div className="me-2">
														<span className="avatar avatar-md rounded-2 bg-danger-transparent text-danger">DT
																												<span className="avatar-status bg-success"></span>
														</span>
												</div>
												<div className="">
														<a href="https://laravelui.spruko.com/velvet/chat">
																<h6 className="fw-semibold mb-0">Dane Tillery</h6>
																<p className="mb-0 fs-12 text-muted"> 10 mins ago </p>
														</a>
												</div>
												<div className="ms-auto">
														<a aria-label="anchor" href="javascript:void(0);" className="btn btn-sm btn-outline-light  me-1"><i className="ri-phone-line text-success"></i></a>
														<a aria-label="anchor" href="javascript:void(0);" className="btn btn-sm btn-outline-light"><i className="ri-chat-3-line text-primary"></i></a>
												</div>
										</div>
										<div className="list-group-item d-flex align-items-center">
												<div className="me-2">
														<a href="https://laravelui.spruko.com/velvet/profile"><img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/16.jpg" alt="img" className="avatar avatar-md rounded-2" /></a>
												</div>
												<div className="">
														<a href="https://laravelui.spruko.com/velvet/chat">
																<h6 className="fw-semibold mb-0">Zelda Perkins</h6>
																<p className="mb-0 fs-12 text-muted"> 3 hours ago </p>
														</a>
												</div>
												<div className="ms-auto">
														<a aria-label="anchor" href="javascript:void(0);" className="btn btn-sm btn-outline-light  me-1"><i className="ri-phone-line text-success"></i></a>
														<a aria-label="anchor" href="javascript:void(0);" className="btn btn-sm btn-outline-light"><i className="ri-chat-3-line text-primary"></i></a>
												</div>
										</div>
										<div className="py-3 fw-semibold ps-2 text-muted">Yesterday</div>
										<div className="list-group-item d-flex align-items-center">
												<div className="me-2">
														<span className="avatar avatar-md rounded-2 bg-primary-transparent text-primary">GB
																												<span className="avatar-status bg-success"></span>
														</span>
												</div>
												<div className="">
														<a href="https://laravelui.spruko.com/velvet/chat">
																<h6 className="fw-semibold mb-0">Gaylord Barrett</h6>
																<p className="mb-0 fs-12 text-muted"> 12:40 pm </p>
														</a>
												</div>
												<div className="ms-auto">
														<a aria-label="anchor" href="javascript:void(0);" className="btn btn-sm btn-outline-light  me-1"><i className="ri-phone-line text-success"></i></a>
														<a aria-label="anchor" href="javascript:void(0);" className="btn btn-sm btn-outline-light"><i className="ri-chat-3-line text-primary"></i></a>
												</div>
										</div>
										<div className="list-group-item d-flex align-items-center">
												<div className="me-2">
														<a href="https://laravelui.spruko.com/velvet/profile"><img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/16.jpg" alt="img" className="avatar avatar-md rounded-2" /></a>
												</div>
												<div className="">
														<a href="https://laravelui.spruko.com/velvet/chat">
																<h6 className="fw-semibold mb-0">Roger Bradley</h6>
																<p className="mb-0 fs-12 text-muted"> 01:00 pm </p>
														</a>
												</div>
												<div className="ms-auto">
														<a aria-label="anchor" href="javascript:void(0);" className="btn btn-sm btn-outline-light  me-1"><i className="ri-phone-line text-success"></i></a>
														<a aria-label="anchor" href="javascript:void(0);" className="btn btn-sm btn-outline-light"><i className="ri-chat-3-line text-primary"></i></a>
												</div>
										</div>
										<div className="list-group-item d-flex align-items-center">
												<div className="me-2">
														<a href="https://laravelui.spruko.com/velvet/profile"><img src="https://laravelui.spruko.com/velvet/build/assets/images/faces/16.jpg" alt="img" className="avatar avatar-md rounded-2" /></a>
												</div>
												<div className="">
														<a href="https://laravelui.spruko.com/velvet/chat">
																<h6 className="fw-semibold mb-0">Magnus Haynes</h6>
																<p className="mb-0 fs-12 text-muted"> 03:53 pm </p>
														</a>
												</div>
												<div className="ms-auto">
														<a aria-label="anchor" href="javascript:void(0);" className="btn btn-sm btn-outline-light  me-1"><i className="ri-phone-line text-success"></i></a>
														<a aria-label="anchor" href="javascript:void(0);" className="btn btn-sm btn-outline-light"><i className="ri-chat-3-line text-primary"></i></a>
												</div>
										</div>
										<div className="list-group-item d-flex align-items-center">
												<div className="me-2">
														<span className="avatar avatar-md rounded-2 bg-secondary-transparent text-secondary">DC
																												<span className="avatar-status bg-gray"></span>
														</span>
												</div>
												<div className="">
														<a href="https://laravelui.spruko.com/velvet/chat">
																<h6 className="fw-semibold mb-0">Doran Chasey</h6>
																<p className="mb-0 fs-12 text-muted"> 06:00 pm </p>
														</a>
												</div>
												<div className="ms-auto">
														<a aria-label="anchor" href="javascript:void(0);" className="btn btn-sm btn-outline-light  me-1"><i className="ri-phone-line text-success"></i></a>
														<a aria-label="anchor" href="javascript:void(0);" className="btn btn-sm btn-outline-light"><i className="ri-chat-3-line text-primary"></i></a>
												</div>
										</div>
										<div className="list-group-item d-flex align-items-center">
												<div className="me-2">
														<span className="avatar avatar-md rounded-2 bg-warning-transparent text-warning">EW
																												<span className="avatar-status bg-danger"></span>
														</span>
												</div>
												<div className="">
														<a href="https://laravelui.spruko.com/velvet/chat">
																<h6 className="fw-semibold mb-0">Ellery Wolfe</h6>
																<p className="mb-0 fs-12 text-muted"> 08:46 pm </p>
														</a>
												</div>
												<div className="ms-auto">
														<a aria-label="anchor" href="javascript:void(0);" className="btn btn-sm btn-outline-light  me-1"><i className="ri-phone-line text-success"></i></a>
														<a aria-label="anchor" href="javascript:void(0);" className="btn btn-sm btn-outline-light"><i className="ri-chat-3-line text-primary"></i></a>
												</div>
										</div>
										<div className="text-center">
												<a href="javascript:void(0)" className="btn btn-sm text-primary text-decoration-underline">View
																										all</a>
										</div>
								</div>
						</div>
						</div>
						</div>
					</Offcanvas>


				</>
			}
		</>
	);
}
